import { isOrdersControlRootTable } from './ordersControlFields';

export const getSelectedOrders = ({
	datasource = [],
	selectedItemIds = [],
	selectionKey = 'id',
}) => {
	const selectedIds = new Set(selectedItemIds);
	return datasource.filter(record => selectedIds.has(record[selectionKey]));
};

export const getUserAssignmentSelectionKey = orders =>
	orders
		.map(order =>
			[
				order.id,
				order.serviceId,
				order.orderZone?.zoneId || order.contractZone?.zoneId || order.zoneId,
				order.central?.id || order.centralId,
			].join(':'),
		)
		.join('|');

export const canShowBulkOrderActions = ({
	selectedSubModule,
	tableContext,
	selectedOrders,
}) =>
	isOrdersControlRootTable(selectedSubModule, tableContext) &&
	selectedOrders.length > 1;
